import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IconList } from '../../../iconlist';
import { environment } from '../../../environments/environment';
import { FormIdentity, ICommonFormDropdownObj, ICommonFormField } from "./common-form.model";
import { CommonService, DocumentsService } from '../../services/common';
import { DocumentSubType } from '../../../appconfig';


@Component({
  selector: 'app-common-form',
  templateUrl: './common-form.component.html',
  styleUrl: './common-form.component.scss'
})
export class CommonFormComponent implements OnInit, OnChanges {

  @Input() commonFormData: any[] = []; // Configuration from the parent component
  @Input() identity!: FormIdentity;
  @Output() formSubmit = new EventEmitter<any>();
  @Output() commonFormDropdownChange = new EventEmitter<ICommonFormDropdownObj>();
  @Output() hideModal = new EventEmitter<any>();
  form!: FormGroup;
  userProfileImage: any = environment.assetsImagePath + IconList.DefaultUserProfilePic;
  userProfilePicOperationIcon = environment.assetsImagePath + IconList.AddIcon;
  documentFileData: any;
  userProfileData: any;
  displayDocumentPicDialogue: boolean = false;
  protected preparedRowData: any[][];
  constructor(private fb: FormBuilder, private commonService:CommonService, private documentService:DocumentsService) {
    this.preparedRowData = [];
  }

  ngOnInit() {
    this.createForm();
    this.preparedRowData = this.createRowData(this.commonFormData);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['commonFormData'] && changes['commonFormData'].currentValue && !changes['commonFormData'].firstChange) {
      this.createForm();
      this.preparedRowData = this.createRowData(this.commonFormData);
    }
  }


  private createForm() {
    const group: any = {};

    this.commonFormData.forEach(field => {
      group[field.name] = [
        field.value || '',
        (field.validations && Object.keys(field.validations).length) ? this.mapValidators(field.validations) : []
      ];
    });

    this.form = this.fb.group(group);
  }

  /**
   * This method creates two dimensional array of rows and columns.
   * @param source The source of data to be converted to desired column and row data
   * @returns
   */
  private createRowData(source: any[]) {
    const result = [];
    let singleRow: any[] = [];

    for (let index = 0; index < source.length; index++) {
      singleRow.push(source[index]);
      if ((index + 1) % 3 === 0 || (index === source.length - 1)) {
        result.push(singleRow);
        singleRow = [];
      }
    }

    return result;
  }


  private mapValidators(validations: any) {
    const validators = [];
    if (validations.required) {
      validators.push(Validators.required);
    }
    if (validations.minLength) {
      validators.push(Validators.minLength(validations.minLength));
    }
    if (validations.maxLength) {
      validators.push(Validators.maxLength(validations.maxLength));
    }

    // Add more validators if needed
    return validators;
  }

  onDropdownClick(field:ICommonFormField, formObj: ICommonFormField[]){
    this.commonFormDropdownChange.emit({
      field,
      formObj,
      identity:this.identity
    })
  }

  onSubmit() {
    const forConsumer = { formIdentity: this.identity, formData: this.form.value };
    this.formSubmit.emit(forConsumer);
  }

    /**
   * Sets the config for file to be uploaded
   * @param documentSubType
   */
    setCurrentFileConfig(documentSubType: any) {
      if (this.documentFileData) {
        this.documentFileData.picFor = this.commonService.addSpaceInCamelCase(documentSubType)
        this.documentFileData.showDocumentNumber = false
      }
      else {
        this.documentFileData = this.documentService.setDocumentFileDataConfig(this.userProfileData?.id, DocumentSubType[documentSubType],
          this.commonService.addSpaceInCamelCase(documentSubType), false)
      }

      this.displayDocumentPicDialogue = true;
    }


  /**
   * Receive currently uploaded file on file dialogue modal
   * @param receivedPicData uploaded file stream
   */
  receiveCurrentUserProfilePic(receivedPicData: any) {
    //Save the received File
    if (receivedPicData && receivedPicData?.documentFile) {
      this.saveDocumentFile(receivedPicData.documentFile)
      this.userProfileImage = receivedPicData?.documentFile?.documentByte
      this.userProfilePicOperationIcon = environment.assetsImagePath + IconList.EditIcon
    }
    // else {
    //   this.userProfileImage = environment.assetsImagePath + IconList.DefaultUserProfilePic;
    // }
    this.displayDocumentPicDialogue = false;
  }

    /**
   * Saves the currently uploaded file
   * @param documentFileData byte data of file to be uploaded
   */
    saveDocumentFile(documentFileData: any) {
      //Save document (Photo) file
      this.documentService.saveDoucmentFile(documentFileData)
    }

      //method use to hide the modal
  Close() {
    this.hideModal.emit();
  }
}
